import HeaderSection from "../../../components/Header/HeaderSection"


export default function BookingText() {

    
    return (

        <HeaderSection

            headline_p1 = "Book your" 
            headline_grey = "counseling session"
            headline_p2 = "here"

            text1 = "If your results show pathogenic or likely pathogenic variants, or if you have variants associated with complex diseases, you shoud talk to a genetic counselor. They can help you understand your results and guide you on next steps, like regular check-ups or screenings, changes in diet, or exercises.  In case of inherited conditions, counseling can provide information on passing this knowledge to family members."
            text2 = "Here, you can easily schedule your (genetic) counseling appointment according to your preferred date and time. After submitting your preferences, you will receive a confirmation email."
            text3 = "Please select your preferred date and time by clicking on the calendar presented in this section."
        />

            
    )
}